import React, { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const ActivityPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { activity, ageGroup } = location.state || {};
  const [score, setScore] = useState(0);
  const [completed, setCompleted] = useState(false);

  // Mock activity data if not provided
  const currentActivity = activity || {
    id: id,
    name: 'Sample Activity',
    type: 'flashcards',
    duration: 5,
    difficulty: 'easy'
  };

  const handleComplete = () => {
    setCompleted(true);
    setScore(Math.floor(Math.random() * 100));
  };

  const isSimpleUI = ageGroup === '6-8';
  const fontSize = isSimpleUI ? '48px' : '32px';
  const buttonFontSize = isSimpleUI ? '24px' : '20px';

  const getActivityContent = () => {
    switch (currentActivity.type) {
      case 'flashcards':
        return (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '🎴' : '🎴 Flashcard Game'}
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: isSimpleUI ? '80px' : '60px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px'
            }}>
              <div style={{ fontSize: isSimpleUI ? '150px' : '120px', marginBottom: '30px' }}>
                🐱
              </div>
              {!isSimpleUI && (
                <p style={{ fontSize: fontSize, fontWeight: '700', color: '#DD2E44' }}>
                  Cat
                </p>
              )}
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: isSimpleUI ? '25px 60px' : '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: buttonFontSize,
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
              }}
            >
              {isSimpleUI ? '➡️' : 'Next Card →'}
            </button>
          </div>
        );
      case 'matching':
        return (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '🔗' : '🔗 Matching Game'}
            </h2>
            {!isSimpleUI && (
              <p style={{ fontSize: '20px', color: '#666', marginBottom: '40px' }}>
                Match the words with the pictures!
              </p>
            )}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {['🐱 Cat', '🐶 Dog', '🐰 Rabbit'].map((item, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: 'white',
                    padding: '40px',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
                    transition: 'all 0.3s ease',
                    fontSize: '24px',
                    fontWeight: '600'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        );
      case 'picture-story':
      case 'story-sequencing':
      case 'story-cubes':
      case 'picture-creation':
        return (
          <div style={{ textAlign: 'center', padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '📖' : '📖 Storytelling with Pictures'}
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: isSimpleUI ? '60px' : '40px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px',
              textAlign: isSimpleUI ? 'center' : 'left'
            }}>
              {isSimpleUI ? (
                <div style={{ fontSize: '120px', marginBottom: '20px' }}>🖼️</div>
              ) : (
                <p style={{ fontSize: '20px', lineHeight: '1.6', color: '#333', marginBottom: '20px' }}>
                  Create your story using the pictures! Drag and drop to sequence your story.
                </p>
              )}
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: isSimpleUI ? '25px 60px' : '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: buttonFontSize,
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              {isSimpleUI ? '✅' : 'Continue →'}
            </button>
          </div>
        );
      case 'simon-says':
      case 'listen-act':
        return (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '👋' : '👋 Simon Says / Listen & Act'}
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: isSimpleUI ? '80px' : '60px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px'
            }}>
              <div style={{ fontSize: isSimpleUI ? '150px' : '120px', marginBottom: '30px' }}>
                👋
              </div>
              {!isSimpleUI && (
                <p style={{ fontSize: fontSize, fontWeight: '700', color: '#DD2E44' }}>
                  Simon says: Jump!
                </p>
              )}
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: isSimpleUI ? '25px 60px' : '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: buttonFontSize,
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              {isSimpleUI ? '✅' : 'I Did It! →'}
            </button>
          </div>
        );
      case 'songs':
        return (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '🎵' : '🎵 Songs & Chants'}
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: isSimpleUI ? '80px' : '60px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px'
            }}>
              <div style={{ fontSize: isSimpleUI ? '150px' : '120px', marginBottom: '30px' }}>
                🎵
              </div>
              {!isSimpleUI && (
                <p style={{ fontSize: fontSize, fontWeight: '700', color: '#DD2E44' }}>
                  Listen and sing along!
                </p>
              )}
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: isSimpleUI ? '25px 60px' : '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: buttonFontSize,
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              {isSimpleUI ? '✅' : 'Next Song →'}
            </button>
          </div>
        );
      case 'small-talk':
      case 'guided-dialogues':
      case 'choice-responses':
        return (
          <div style={{ textAlign: 'center', padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ fontSize: isSimpleUI ? '32px' : '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {isSimpleUI ? '💬' : '💬 Conversation & Small Talk'}
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: isSimpleUI ? '60px' : '40px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px'
            }}>
              {isSimpleUI ? (
                <div style={{ fontSize: '120px', marginBottom: '20px' }}>💬</div>
              ) : (
                <p style={{ fontSize: '20px', lineHeight: '1.6', color: '#333', marginBottom: '20px' }}>
                  Practice real-life conversations! Choose how to respond.
                </p>
              )}
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: isSimpleUI ? '25px 60px' : '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: buttonFontSize,
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              {isSimpleUI ? '✅' : 'Continue →'}
            </button>
          </div>
        );
      case 'read-act':
      case 'find-clues':
      case 'text-sequencing':
        return (
          <div style={{ textAlign: 'center', padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '36px', marginBottom: '30px', color: '#DD2E44' }}>
              📚 Reading & Comprehension
            </h2>
            <div style={{
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px',
              textAlign: 'left'
            }}>
              <p style={{ fontSize: '20px', lineHeight: '1.6', color: '#333', marginBottom: '20px' }}>
                Read this short story and answer the questions...
              </p>
            </div>
            <button
              onClick={handleComplete}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: '20px 50px',
                borderRadius: '25px',
                border: 'none',
                fontSize: '20px',
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              Continue Reading →
            </button>
          </div>
        );
      default:
        return (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h2 style={{ fontSize: '36px', marginBottom: '30px', color: '#DD2E44' }}>
              {currentActivity.name}
            </h2>
            <p style={{ fontSize: '20px', color: '#666', marginBottom: '40px' }}>
              This activity is coming soon! 🚀
            </p>
            <div style={{
              backgroundColor: 'white',
              padding: '60px',
              borderRadius: '25px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
              marginBottom: '30px'
            }}>
              <div style={{ fontSize: '120px' }}>🎮</div>
            </div>
          </div>
        );
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      padding: '40px 20px',
      paddingTop: '100px'
    }}>
      {completed ? (
        <div style={{
          maxWidth: '600px',
          margin: '0 auto',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '60px',
          borderRadius: '25px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '120px', marginBottom: '30px' }}>🎉</div>
          <h2 style={{ fontSize: '36px', color: '#DD2E44', marginBottom: '20px' }}>
            Great Job!
          </h2>
          <p style={{ fontSize: '24px', color: '#666', marginBottom: '30px' }}>
            You scored {score} points! ⭐
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
            <button
              onClick={() => navigate('/dashboard/learning-hub')}
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
                padding: '20px 40px',
                borderRadius: '25px',
                border: 'none',
                fontSize: '18px',
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              Back to Hub
            </button>
            <button
              onClick={() => setCompleted(false)}
              style={{
                backgroundColor: 'white',
                color: '#DD2E44',
                padding: '20px 40px',
                borderRadius: '25px',
                border: '2px solid #DD2E44',
                fontSize: '18px',
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      ) : (
        <>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ marginBottom: '30px', textAlign: 'center' }}>
              <button
                onClick={() => navigate('/learning-hub')}
                style={{
                  backgroundColor: 'white',
                  color: '#DD2E44',
                  padding: '10px 25px',
                  borderRadius: '20px',
                  border: '2px solid #DD2E44',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  marginBottom: '20px'
                }}
              >
                ← Back
              </button>
              <h1 style={{
                fontSize: '42px',
                fontWeight: '800',
                color: '#DD2E44',
                marginBottom: '10px'
              }}>
                {currentActivity.name}
              </h1>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
                fontSize: '16px',
                color: '#666'
              }}>
                <span>⏱️ {currentActivity.duration} min</span>
                <span>📊 {currentActivity.difficulty}</span>
              </div>
            </div>
            <div>
              {getActivityContent()}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ActivityPage;